import { type PageContext } from 'vike/types'
import { redirect } from 'vike/abort'
const routeRegex = /\/(buy|rent)((\/[^/]+)*)\/detail\/([A-Z^/_]+)/
export function route(pageContext: PageContext) {
  const match = pageContext.urlPathname.match(routeRegex)
  if (!match) return false
  throw redirect(pageContext.urlPathname.replace('/detail', '/property'), 301)
}
